import { render, staticRenderFns } from "./subsidy-card.vue?vue&type=template&id=1b46df19&scoped=true&lang=pug&"
import script from "./subsidy-card.vue?vue&type=script&lang=js&"
export * from "./subsidy-card.vue?vue&type=script&lang=js&"
import style0 from "./subsidy-card.vue?vue&type=style&index=0&id=1b46df19&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b46df19",
  null
  
)

export default component.exports